import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'kh-student-question-attempt-modal',
    templateUrl: './student-question-attempt-modal.component.html',
    styleUrls: ['./student-question-attempt-modal.component.less'],
    standalone: false
})
export class StudentQuestionAttemptModalComponent {
  public attemptId = '';
  public itemOrder = 0;
  public isTeacher = true;
  public hideActions = false;
  public isDemo = false;
  public isModal = true;
  public isSingleChoice = false;
  public hideName = false;

  public constructor(private readonly bsModalRef: BsModalRef) { }

  public closeModal(): void {
    this.bsModalRef.hide();
  }
}
